import React from 'react';
import TableCell from './TableCell';
import ActionButtons from './ActionButtons';

const TableRow = ({
  row = {},
  headers = [],
  actions = [],
  actionsDisplayMode = 'inline',
  className = '',
  onRowClick,
  statusConfig = {},
  grid = false,
  showActions = true,
  onActionClick,
}) => {
  if (!row || !headers) return null;

  // Ensure actions is always an array
  const filteredActions = (actions || []).filter(action => {
    if (typeof action.showIf === 'function') {
      return action.showIf(row);
    }
    return true;
  });

  const viewAction = filteredActions.find(action => action.variant === 'primary');

  const handleRowClick = (e) => {
    if (e.target.closest('.action-buttons')) return;

    if (onRowClick) {
      onRowClick(row);
    } else if (viewAction) {
      viewAction.onClick(row);
    }
  };

  const renderCellValue = (value, header) => {
    if (value === null || value === undefined) return '--';

    if (header.key === 'status' && statusConfig[value]) {
      return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${statusConfig[value].className}`}>
          {statusConfig[value].label}
        </span>
      );
    }

    if (header.render && typeof header.render === 'function') {
      return header.render(value, row);
    }

    if (typeof value === 'object') {
      if (value.name) return value.name;
      if (value.label) return value.label;
      if (value.id) return value.id;
      return JSON.stringify(value);
    }

    return value;
  };

  const hasActions = filteredActions.length > 0;

  return (
    <tr
      onClick={handleRowClick}
      className={`${onRowClick ? 'cursor-pointer hover:bg-gray-50' : 'cursor-pointer'} ${className}`}
    >
      {headers.map((header) => {
        const cellValue = renderCellValue(row[header.key], header);

        return (
          <TableCell
            key={header.key}
            className="px-4 py-3 text-sm text-gray-800 border-b border-gray-200 whitespace-nowrap"
          >
            <span
              data-tooltip-id="table-tooltip"
              data-tooltip-content={header.tooltipEnabled ? String(cellValue) : undefined}
              className="truncate max-w-[220px] block text-ellipsis overflow-hidden"
            >
              {cellValue}
            </span>
          </TableCell>
        );
      })}
      {actionsDisplayMode !== 'none' && showActions && hasActions && (
        <TableCell
          className={`px-4 py-2.5 whitespace-nowrap text-right text-sm font-medium sticky right-0 bg-white z-5 shadow-[-8px_0_12px_-6px_rgba(0,0,0,0.25)] ${grid ? 'border-x border-gray-200' : ''}`}
        >
          <ActionButtons
            row={row}
            actions={filteredActions}
            displayMode={actionsDisplayMode}
            className="action-buttons"
          />
        </TableCell>
      )}
    </tr>
  );
};

export default TableRow;
